import { useEffect, useState } from "react";

/** Build id of the code running in this tab (vite.config.ts writes the same id into /version.json). */
const RUNNING = typeof __WMS_BUILD__ === "string" ? __WMS_BUILD__ : "";

async function deployedBuild(): Promise<string | null> {
  try {
    const response = await fetch("/version.json", { cache: "no-store" });
    if (!response.ok) return null;
    const data = (await response.json()) as { build?: unknown };
    return typeof data.build === "string" ? data.build : null;
  } catch {
    return null;
  }
}

/**
 * 29.10.2026: a tab left open across a release keeps the old code while the API is already new (a button of the new
 * server opened the wrong dialog). The tab asks /version.json on focus and every few minutes and says when to reload.
 */
export function useNewRelease(): boolean {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    if (!import.meta.env.PROD || !RUNNING) return;
    let alive = true;
    const check = () => {
      deployedBuild().then((build) => {
        if (alive && build && build !== RUNNING) setStale(true);
      });
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    check();
    const timer = window.setInterval(check, 3 * 60_000);
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      alive = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
  return stale;
}
